import React from 'react';
import matchSorter from 'match-sorter';
import { get } from 'lodash';
import { StyledInput, StyledDropdown } from 'components/atoms/tables/smarttables/CommonAssets';

// Define a default UI for filtering
function DefaultColumnFilter({
    column: { filterValue, preFilteredRows, setFilter },
}) {
    const count = preFilteredRows.length;

    return (
        <div>
            <input
                value={filterValue || ''}
                onChange={(e) => {
                    setFilter(e.target.value || undefined); // Set undefined to remove the filter entirely
                }}
                placeholder={`Search ${count} records...`}
            />
        </div>
    );
}

// This is a custom filter UI for selecting
// a unique option from a list
function SelectColumnFilter({
    column: { setFilter, preFilteredRows, id }
}) {
    // Calculate the options for filtering
    // using the preFilteredRows
    const options = React.useMemo(() => {
        const optionValues = new Set();
        preFilteredRows.forEach((row) => {
            optionValues.add(row.values[id]);
        });
        return [...optionValues.values()];
    }, [id, preFilteredRows]);

    const optionsForSelect = React.useMemo(() => [
        { key: 'all', text: 'All' },
        { key: 1, text: '', value: '--NO VALUE--' },
        ...options.filter(opt => opt && opt !== '--NO VALUE--').sort().map((value, i) => ({
            key: i + 2, text: value, value
        }))
    ], [options]);

    return (<StyledDropdown
        placeholder={'Filter'}
        fluid
        search
        selection
        options={optionsForSelect}
        defaultValue={optionsForSelect[0].value}
        onChange={(e, data) => {
            setFilter(data.value || undefined);
        }}
    />);
}


function columnFilterFn(rows, id, value) {
    const filterFn = get(value, 'fn', null);
    return typeof filterFn === 'function'
        ? filterFn(rows, id, get(value, 'value', null))
        : rows;
}

function fuzzyTextFilterFn(rows, id, filterValue) {
    return matchSorter(rows, filterValue, { keys: [row => row.values[id]] });
}

// Let the table remove the filter if the string is empty
fuzzyTextFilterFn.autoRemove = val => !val;

// Define a default UI for filtering
function GlobalFilter({
    width = null,
    maxwidth = null,
    minwidth = null,
    globalFilter,
    setGlobalFilter,
    placeholder = 'Search table data...'
}) {
    return (
        <StyledInput
            width={width}
            maxwidth={maxwidth}
            minwidth={minwidth}
            key="globalSearch"
            value={globalFilter || ''}
            icon='search'
            fluid
            onChange={(e) => {
                setGlobalFilter(e.target.value || undefined); // Set undefined to remove the filter entirely
            }}
            placeholder={placeholder}
        />
    );
}

export {
    DefaultColumnFilter,
    GlobalFilter,
    SelectColumnFilter,
    fuzzyTextFilterFn,
    columnFilterFn,
};



// WEBPACK FOOTER //
// ./src/components/atoms/tables/smarttables/Filters.js